export default "__VITE_ASSET__BfHYmwm9__"